import * as React from 'react';

const SvgSigmanauts = (props) => (
  <svg width={248} height={300} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M107.152 267.965 73.84 286.524c35.611-4.929 64.83-11.723 99.771-20.208l38.859 23.404c6.495-1.237 32.992-17.754 28.446-27.91 6.99-7.753 7.464-13.269 3.917-17.414h-99.162l8.877 1.65c6.804 1.258 5.546 2.413-.619 3.413l-26.147 3.361c-7.98.928-8.248 6.526 2.66 7.815 4.98.474 2.97 3.835-4 4.753l-19.29 2.577Z"
      fill="url(#sigmanauts_svg__a)"
      stroke="#000"
      strokeWidth={1.031}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M218.437 27.43c12.964-8.712 22.119-17.79 20.448-20.275-1.67-2.486-13.534 2.56-26.498 11.272-12.964 8.711-22.119 17.788-20.448 20.274 1.67 2.486 13.534-2.56 26.498-11.272Z"
      stroke="#585858"
      strokeWidth={1.691}
      strokeMiterlimit={10}
    />
    <path
      d="M52.512 206.829v24.27l13.238 13.32h81.749M52.512 118.471v46.498-46.498Z"
      stroke="#FF5E18"
      strokeWidth={1.031}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.929 46.3h12.238l8.928 6.495v156.498l-8.928 6.485H9.929L1 209.293V52.795L9.929 46.3Z"
      stroke="#FF5E18"
      strokeWidth={1.031}
      strokeMiterlimit={10}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.436 46.3h7.733l8.929 6.495v156.498l-8.929 6.485h-7.733l-8.928-6.485V52.795l8.928-6.495Z"
      fill="url(#sigmanauts_svg__b)"
      stroke="#FF5E18"
      strokeWidth={1.031}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M84.251 217.942c-6.753 3.382-17.919 4.67-19.32-5.382-.589-4.124-3.754-14.434-11.754-6.434-6.774 6.826-17.332 4.259-20.074-5.711-3.64-13.331-9.403-14.806-18.033-12.878 10.393-11.588 54.54-25.559 68.563-48.653"
      stroke="#807e7e"
      strokeWidth={1.031}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M106.647 71.207c17.692 5.97 38.148 3.867 53.386-.474 11.145 3.093 22.816 6.805 32.724 17.61 3.093 3.36 4.795 12.826 5.351 17.661.196 1.794.361 3.619.557 5.464 1.547 15.466 1.547 13.826-9.279 30.766l3.608.33 7.867 7.619v13.816l-10.248 15.114-10.661 8.032c3.856 8.815 5.258 18.651 7.382 28.023l3.784 10.671 6.526 20.404a113.228 113.228 0 0 0 7.867 20.743l2.629 5.465a42.758 42.758 0 0 1 3.774 9.877c.763 5.155 1.938 12.176-4.423 14.527-5.619 2.062-12.847 3.474-18.363.309-5.289-2.99-5.846-4.474-7.475-14.217-.948-.568-1.897-1.093-2.856-1.65-4.897-2.444-4.783-3.341-5.485-9.104-.195-1.598-.278-2.907.506-3.67-.815-3.465 1.031-5.423.309-9.042a59.649 59.649 0 0 0-3.722-11.393c-2.237-5.403-4.619-10.723-7.001-16.063l-4.227-9.547a196.267 196.267 0 0 1-24.424-38.89l-.671-1.031c-4.619 11.001-9.578 21.888-19.589 34.405l-2.825 9.939-2.299 24.074c-.423 4.258-.361 2.856.979 6.557 1.093 3.093 1.093 5.928 1.258 9.434.877 1.454.815 1.144.815 2.825v4c-2.351 3.722-9.372 4.732-12.733 5.073-7.537.752-9.94 2.124-16.435 4.866-9.609 4.124-20.414 4.732-26.538-.165v-4.619c0-1.99-.144-1.515 1.258-2.938 2.382-6.186 7.506-7.145 14.692-9.774a117.936 117.936 0 0 1 10.67-11.867l2.238-28.497c-3.02-7.898-.752-15.094 3.98-19.177l.897-11.537-1.371-.279c-3.815-.783-5.66-.814-5.155-5.876l1.958-14.868c.372-2.804 1.434-3.196 4.011-3.196h2.99l3.33-15.898c-2.062-.557-1.31-8.248.114-8.99.752-6.351 1.03-9.486 3.093-15.558l-1.68-.784-2.568.701c-3.815 1.959-10.475 2.681-16.888 1.732-21.414-3.196-14.61-28.332-2.66-39.642-3.02-10.97.196-20.94-10.248-28.384-2.062-1.825-.835-6.135 1.773-4.258l26.167 18.702c2.97-3.03 7.702-6.443 13.331-7.35Z"
      fill="url(#sigmanauts_svg__c)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M99.447 130.43c-1.99 5.794-2.351 8.929-3.021 14.754 1.65-3.196 4.062-6.836 7.031-9.022-.536-.391-1.031-.783-1.598-1.144a2.282 2.282 0 0 1-1.124-1.78 2.282 2.282 0 0 1 .815-1.942l.309-.196a28.966 28.966 0 0 1-4.124-1.454l1.712.784Z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M181.56 119.448c-8.145-1.196-10.661 8.176-17.043 16.692l-5.155-5.155 4.207-6.629 4.124-4.506-10.826-18.744 2.062-18.063 8.351-3.939c-4.423 9.166 4.485 27.889 14.28 40.344Z"
      fill="#FF5E18"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M171.571 75.559c-4.99 1.68-14.434 4.361-20.435 5.733l-8.062 5.515 1.618-.051.65-1.32h6.547l1.031 1.34 2.598.052.814 5.207-1.464 11.97-11.341-.598-2.33-.103-.897-3.093v-.145l2.062-12.795c-5.155 3.609-9.124 8.434-12.96 13.156l6.186 5.32a41.23 41.23 0 0 1 13.888 1.155 31.044 31.044 0 0 1 8.393 3.691 40.062 40.062 0 0 1 9.908 9.186 53.761 53.761 0 0 1-4.898-10.949 53.756 53.756 0 0 1-1.928-8.403c-1.031-7.104-.226-13.857 3.093-18.249.444-1.515 3.609-5.371 13.517-5.402 1.093.154-4.134-1.3-5.99-1.217Z"
      fill="#fff"
    />
    <path
      d="M97.457 218.808c6.104 0 5.433-4.505 6.248-10.135.919-7.444 2.454-14.8 4.588-21.991 2.382-7.733 5.238-15.208 8.011-23.043.474-2.062.918-4.176 1.402-6.269M116.716 214.127c-4.392-4.392-8.733-7.475-4.619-16.764a203.956 203.956 0 0 1 11.228-21.723M132.184 157.864c4.124 14.95 8.794 21.889 16.238 35.127 1.516 2.835 3 5.66 4.506 8.485 2.237 4.227 4.289 8.248 6.248 12.372 3.247 6.722 3.247 9.218 8.866 9.279M161.18 194.476c3.866 6.186 5.969 11.784 8.712 18.898M175.77 189.661c2.907 8.846 3.691 16.857 9.598 16.269M181.371 230.87c.897 2.155 1.794 4.341 2.722 6.495M89.314 227.457c-.113 1.846-.36 4.454-.36 6.3M100.996 234.963c1.34-6.279 1.289-11.176 11.341-10.424M162.16 229.158c6.3 0 7.372 5.743 9.444 11.341M104.051 174.041a90.084 90.084 0 0 0 4.619-17.414"
      stroke="#000"
      strokeWidth={1.031}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M106.991 164.688c-4.537-.556-4.929-1.031-7.589 7.279M114.152 169.73l4.124 1.093M136.4 170.185c-2.062.257-3.495.505-5.505.732M146.623 171.721c-.835-1.207-1.681-2.382-2.516-3.557-.278-1.124-.567-2.238-.845-3.393M169.387 141.008c7.815-8.505 9.794-14.434 18.506-10.104"
      stroke="#000"
      strokeWidth={1.031}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M180.641 141.904c10.464-16.372 12.31-14.98 10.495-34.095M162.773 108.87c1.516-.443 3.001-.866 4.506-1.32a3.178 3.178 0 0 1 3.949 1.763c.227.423.474.877.701 1.32 1.711 3.093 4.763 3.722 6.299.144 1.32-3 2.609-6.021 3.918-9.021"
      stroke="#000"
      strokeWidth={1.031}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M178.578 97.725c-2.443 6.361-3.093 4.794 1.031 9.939M176.412 94.365a33.835 33.835 0 0 0-7.506.257c-1.763.248-2.433.64-2.35 2.547.195 3.413-.31 2.547-3.918 3.093l-1.794.248M163.898 82.22c4.98.165 9.207 1.258 12.816 4.732M174.816 77.064a18.366 18.366 0 0 1 3.248 2.578M149.374 106.943c-.392 3.217-.783 6.382-1.206 9.599M157.768 110.582a34.947 34.947 0 0 0-1.598 10.826c1.031.113 2.918 0 3.835.371a81.66 81.66 0 0 0 .258 8.248M137.136 83.815a32.701 32.701 0 0 0-3.64 10.888M110.707 147.728c.083-2.268-.392-9.279 5.99-9.279h3.887M71.352 97.395c-2.062 5.403-3.021 9.517-1.32 11.228.815.639 1.031.835 1.846 1.475 3.093 2.464 5.299 2.268 7.959-.753a10.774 10.774 0 0 1 8.454-3.753"
      stroke="#000"
      strokeWidth={1.031}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M70.82 100.642c4.557.897 3.743.805 7.217-2.64M65.637 108.984c-.278 5.341 3.093 9.96 8.65 13.857 2.609 1.846 3.31 1.031 4.063-1.515.36-1.196.7-2.382 1.03-3.578 1.681.722 3.362 1.423 5.011 2.155M93.627 110.665c-7.753 1.846-10.31 10.97-8.062 16.094M64.43 117.047c3.98 8.537 8.062 6.825 9.97 14.104"
      stroke="#000"
      strokeWidth={1.031}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M85.574 128.161a1.402 1.402 0 1 0 0-2.804 1.402 1.402 0 0 0 0 2.804ZM191.14 109.21a1.403 1.403 0 1 0 0-2.806 1.403 1.403 0 0 0 0 2.806Z"
      fill="#000"
      stroke="#000"
      strokeWidth={0.227}
      strokeMiterlimit={10}
    />
    <path
      d="M103.203 212.93c1.705.128 3.378.525 4.959 1.175"
      stroke="#000"
      strokeWidth={1.031}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M108.164 215.508a1.402 1.402 0 1 0 0-2.803 1.402 1.402 0 0 0 0 2.803Z"
      fill="#FF5E18"
      stroke="#000"
      strokeWidth={0.227}
      strokeMiterlimit={10}
    />
    <path
      d="M118.297 172.227a1.402 1.402 0 1 0 0-2.805 1.402 1.402 0 0 0 0 2.805ZM130.898 172.309a1.402 1.402 0 1 0 0-2.803 1.402 1.402 0 0 0 0 2.803Z"
      fill="#000"
      stroke="#000"
      strokeWidth={0.227}
      strokeMiterlimit={10}
    />
    <path
      d="m91.84 206.828 1.515-11.29"
      stroke="#000"
      strokeWidth={1.031}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m142.985 123.43-15.207 18.476c-1.031 1.319-1.681 2.886-.114 4.227l2.825 2.825 1.743 1.742.866.887c.066-1.164.383-2.3.928-3.33 1.649-2.372 5.371-.588 5.258 3.309 1.794-1.454 3.701.113 4.567 2.382a6.812 6.812 0 0 1 .413 3.186c1.35-2.238 3.67-1.341 4.763.845.36.74.56 1.548.588 2.371.015.292.015.585 0 .877 0 .391-.134.804-.217 1.227l-.422 2.237a3.184 3.184 0 0 0 .732 2.402l-1.031 1.701 10.547-14.753 9.413-5.764 4.98-3.093-4.227-4.227-9.713-9.712-8.763-8.764-1.031-.536c-2.67-1.536-4.97-.835-6.898 1.485Z"
      fill="#000"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M65.407 64.052c10.444 7.444 7.217 17.414 10.248 28.384a25.09 25.09 0 0 0 2.351 5.568 23.213 23.213 0 0 0 3.928 4.99 10.416 10.416 0 0 1 6.382 2.598 62.606 62.606 0 0 1 5.31 5.073c.875.887 1.812 1.71 2.804 2.464l4.764 2.907c4.051.454 6.938.65 9.794 1.124l2.062-2.969c-.618-1.732-.278-4.124 1.763-6.413l6.723-7.558c-.681-.474-1.351-1.03-2.063-1.515a722.087 722.087 0 0 1-7.639-5.96s-.062 0-.062-.051l-6.392-4.99c-3.753-2.938-7.754-6.021-12.043-9.155L67.232 59.794c-2.66-1.876-3.887 2.434-1.825 4.258Z"
      fill="url(#sigmanauts_svg__d)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M166.773 239.634c.65 1.485 1.351 3.093 2.062 4.733.65 1.505 1.32 3.093 1.959 4.67 5.155 3.093 6.671 12.681 8.094 20.435.34 1.711.649 3.34.979 4.794.65 1.227 1.207 2.577 1.825 4.031.804 1.897 1.681 3.805 2.598 5.537 3.331 6.248 5.856 8.042 13.404 7.619 4.227-.248 8.753-1.454 11.083-3.949a6.25 6.25 0 0 0 1.175-1.907c.835-2.155.639-4.836.423-8.032-.392-.917-.784-1.866-1.175-2.711-.196-.475-.423-.928-.619-1.403a.864.864 0 0 1-.113-.247l-2.516-5.155-.505-1.031a113.238 113.238 0 0 1-7.867-20.744l-.588-1.846-4.505-14.083c-.196 2.66-3.897 5.206-8.454 7.083a42.933 42.933 0 0 1-12.486 3.093c-2.248.093-4.011-.155-4.774-.887Z"
      fill="url(#sigmanauts_svg__e)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m85.07 232.603-.927 11.763-.784 9.939a118.045 118.045 0 0 0-10.671 11.867c-7.217 2.629-12.31 3.588-14.692 9.774 2.63 3.093 7.279 3.526 11.898 3.3 5.825-.31 8.96-1.124 12.372-2.63 3.949-1.763 6.444-2.855 8.65-3.608 6.413-12.042 8.547-26.043 18.93-26.683l.196-1.959.979-10.083a67.183 67.183 0 0 1-9.99.681 56.653 56.653 0 0 1-12.043-1.207 28.708 28.708 0 0 1-3.918-1.154Z"
      fill="url(#sigmanauts_svg__f)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M109.815 246.325c-10.382.639-12.517 14.641-18.93 26.683-2.206.752-4.701 1.845-8.65 3.608-3.382 1.506-6.516 2.32-12.372 2.629-4.619.227-9.28-.247-11.898-3.299-1.402 1.423-1.258.949-1.258 2.939v4.619c4.124 3.33 10.465 4.124 17.105 2.989a41.821 41.821 0 0 0 9.434-2.824c6.495-2.743 8.897-4.125 16.434-4.867 3.361-.34 10.382-1.351 12.733-5.072v-4.001c0-1.484.062-1.433-.557-2.412a3.319 3.319 0 0 1-.258-.413c-.165-3.505-.165-6.361-1.257-9.434-1.341-3.701-1.403-2.299-.98-6.557l.454-4.588Z"
      fill="url(#sigmanauts_svg__g)"
    />
    <path
      d="M200.015 253.831c1.54 4.49 3.372 8.874 5.485 13.125l2.629 5.464a42.79 42.79 0 0 1 3.773 9.877c.347 1.904.554 3.83.619 5.764m-11.135 10.475c-4.207.783-8.63.701-12.269-1.402-5.289-2.99-5.846-4.475-7.475-14.218-.949-.567-1.897-1.093-2.856-1.65-4.897-2.443-4.784-3.34-5.485-9.104-.196-1.598-.278-2.907.505-3.67-.814-3.464 1.031-5.423.31-9.042a59.79 59.79 0 0 0-3.722-11.393c-2.238-5.402-4.619-10.722-7.001-16.063l-4.227-9.547a196.29 196.29 0 0 1-24.415-38.859l-.67-1.031m-34.374 96.307c-7.536.753-9.939 2.124-16.434 4.866-9.61 4.125-20.414 4.733-26.538-.165v-4.618c0-1.99-.145-1.516 1.258-2.939 2.381-6.186 7.505-7.145 14.691-9.774a117.923 117.923 0 0 1 10.671-11.867l2.238-28.497c-3.021-7.898-.753-15.094 3.98-19.177l.896-11.537-1.37-.278c-3.816-.784-5.661-.815-5.156-5.877l1.959-14.867c.371-2.805 1.433-3.196 4.01-3.196h2.99l3.33-15.899c-2.061-.556-1.309-8.248.114-8.99.753-6.351 1.031-9.485 3.093-15.558l-1.68-.784-2.567.702a19.82 19.82 0 0 1-5.238 1.649m-17.775-1.763c-7-3.443-8.712-10.609-7.31-18.146m3.392-45.694a21.003 21.003 0 0 0-2.835-2.403c-2.062-1.824-.835-6.134 1.773-4.258l26.168 18.703c2.938-2.97 7.67-6.382 13.3-7.31 17.692 5.97 38.147 3.866 53.385-.474 11.146 3.093 22.817 6.805 32.725 17.61m-7.166 118.783c.588 2.721 1.124 5.433 1.732 8.093M70.303 98.993a36.087 36.087 0 0 1 5.34-6.495 60.93 60.93 0 0 1-1.618-10.073l-3.722 16.569Zm119.092 43.221 3.609.33 7.866 7.619v13.836l-10.248 15.115-10.661 8.031a66.183 66.183 0 0 1 2.403 6.557l7.031-51.488Z"
      stroke="#fff"
      strokeWidth={1.031}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M185.951 82.136a50.85 50.85 0 0 1 6.805 6.187 12.353 12.353 0 0 1 2.134 3.69l.248 5.32-4.372 5.465-8.619-1.031-5.681-6.382-.392-7.64 5.155-6.103 4.722.495Z"
      fill="#fff"
      stroke="#000"
      strokeWidth={1.031}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m132.232 150.699.866.887c.066-1.164.383-2.3.928-3.33 1.649-2.372 5.371-.588 5.258 3.309 1.794-1.453 3.701.114 4.567 2.382a6.812 6.812 0 0 1 .413 3.186c1.35-2.238 3.67-1.341 4.763.845a6.06 6.06 0 0 1 .557 3.248c-.217 2.01-1.454 4.052.113 5.877l-1.031 1.701 10.548-14.754 8.124-4.98-25.641-24.074-13.919 16.909c-1.031 1.319-1.681 2.887-.114 4.227l2.825 2.825 1.743 1.742Z"
      fill="#000"
    />
    <path
      d="M74.445 105.283c11.568-6.743 15.466 2.969 22.033 7.846-7.588 3.691-8.34 13.712-1.227 17.218"
      stroke="#fff"
      strokeWidth={1.031}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M89.574 206.632a15.682 15.682 0 0 0-5.32 11.341 19.796 19.796 0 0 0 1.34 7.867 7.209 7.209 0 0 0 2.97 1.484c.244.08.496.135.752.165a5.09 5.09 0 0 0 5.042-1.319c1.711-1.681 2.69-4.454 3.093-7.331.418-2.663.39-5.377-.083-8.032-.36-1.68-1.175-2.526-3.577-3.392a13.86 13.86 0 0 0-1.96-.556l-2.257-.227Z"
      fill="#fff"
    />
    <path
      d="M167.671 119.82c-10.104-16.806-12.093-45.303 10.475-42.56"
      stroke="#fff"
      strokeWidth={1.031}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m178.621 88.353.392 5.702 4.423 4.877 6.671 1.093 3.557-4.032V89.53"
      stroke="#000"
      strokeWidth={1.031}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m85.542 176.505-1.629 12.434c-.474 5.063 1.371 5.094 5.155 5.877l1.371.278v.052c1.031.093 2.01.289 2.877.392l.65.093 3.247.412c2.485.423 4.124-.196 4.897-2.907a58.447 58.447 0 0 0 1.031-4.197c-.226-.062-.474-.144-.721-.196-2.526-.68-.794-6.248 1.144-5.691.227.062.474.145.701.196.279-1.567.557-3.217.897-5.031a3.187 3.187 0 0 0-.68-2.836 21.84 21.84 0 0 0-5.155-3.412c-1.403-.639-3.609-.784-6.527-1.093h-2.886c-2.578 0-3.64.392-4.011 3.196l-.361 2.433Z"
      fill="#fff"
    />
    <path d="m190.109 100.024.671 2.774" stroke="#fff" strokeWidth={1.031} strokeMiterlimit={10} />
    <path
      d="m183.433 98.93-1.288 2.826M176.469 95.375l2.546-1.31"
      stroke="#000"
      strokeWidth={1.031}
      strokeMiterlimit={10}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M133.136 17.357c19.146 0 34.652 14.64 34.652 32.725a31.468 31.468 0 0 1-7.753 20.62c-15.28 4.34-35.694 6.444-53.386.474a31.737 31.737 0 0 1-8.145-21.105c0-18.042 15.506-32.714 34.632-32.714Z"
      fill="url(#sigmanauts_svg__h)"
      stroke="#000"
      strokeWidth={1.031}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M191.55 227.179c32.034-23.466 40.21-59.18 31.271-96.616a83.194 83.194 0 0 0-4.196-12.733c-10.383-24.414-27.91-46.499-55.005-52.18-.34.609-.959 1.588-1.68 2.66 5.371 3.33-32.312 12.228-38.746 11.95-8.764-.361-13.3-4.67-20.105-8.145l3.784-.846a44.692 44.692 0 0 1-3.784-4.897c-6.804 1.155-9.155 6.135-7.588 9.805 3.897 9.094 28.528 8.98 41.014 7.691 1.175-.113 2.237-.247 3.165-.36a182.77 182.77 0 0 0 28.528-7.001c4.124-1.402 5.258-1.536 9.042.31a50.863 50.863 0 0 1 13.805 9.742 30.089 30.089 0 0 1 4.475 5.826 112.871 112.871 0 0 1 10.021 18.444c16.713 38.272 10.022 65.336-12.176 88.606 13.042-8.764 13.775 15.279-1.825 27.744Z"
      fill="url(#sigmanauts_svg__i)"
      stroke="#000"
      strokeWidth={1.031}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M75.66 92.436a23.259 23.259 0 0 0 6.279 10.558"
      stroke="#fff"
      strokeWidth={1.031}
      strokeMiterlimit={10}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m110.09 118.417 5.877 10.918 2.526 2.547c2.319 2.32 2.711 3.186 2.268 5.712-.784 4.309-2.268 3.887.979 7.134l1.031 1.031a3.978 3.978 0 0 0 4.929.392c-1.568-1.34-.949-2.907.113-4.227l15.207-18.476c1.928-2.32 4.228-3.021 6.857-1.433l1.031.536c.639-1.32 1.206-2.32-.454-4.031l-22.589-19.208c-2.124-1.505-5.032-.443-6.321.928l-6.722 7.557c-2.062 2.269-2.381 4.681-1.763 6.413l-2.969 4.207Zm15.145 6.33 1.227 1.031a2.306 2.306 0 0 1 .196 3.217l-1.763 1.99a2.33 2.33 0 0 1-3.217.196l-1.206-1.093a2.26 2.26 0 0 1-.767-1.557 2.25 2.25 0 0 1 .571-1.639l1.763-1.98a2.225 2.225 0 0 1 3.196-.165Z"
      fill="#FF5E18"
      stroke="#000"
      strokeWidth={1.031}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m145.5 173.205-.082 11.022 8.176 9.609-.67-12.712 13.547-19.425 20.208-12.795 14.166 1.258-7.753-7.722h-3.495l-10.413-.619-19.961 12.228-13.723 19.156Z"
      fill="#807e7e"
      stroke="#fff"
      strokeWidth={1.031}
      strokeLinejoin="round"
    />
    <path
      d="m150.906 122.532 22.703 22.703M127.684 146.132l5.423 5.454"
      stroke="#fff"
      strokeWidth={1.031}
      strokeMiterlimit={10}
    />
    <path
      d="M135.488 105.788c14.579-1.031 24.044 3.815 32.189 14.032M129.27 100.468c3.835-4.722 7.835-9.547 12.959-13.156M96.426 145.182c1.65-3.196 4.062-6.835 7.031-9.021"
      stroke="#000"
      strokeWidth={1.031}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m140.215 100.108.928 3.196 13.681.701 1.485-11.99-.815-5.207-2.598-.052-1.01-1.35-6.547.03-.639 1.32-2.382.082-2.103 13.27Z"
      fill="#fff"
      stroke="#000"
      strokeWidth={1.031}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m140.242 100.252 12.847.474.948-8.537"
      stroke="#000"
      strokeWidth={1.031}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m144.702 86.756-1.155 8.98 8.011.31.752-6.383M143.07 86.807l8.063-5.516"
      stroke="#000"
      strokeWidth={1.031}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M96.203 154.978a237.461 237.461 0 0 0 38.045 2.907"
      stroke="#fff"
      strokeWidth={1.031}
      strokeMiterlimit={10}
    />
    <path
      d="M124.535 140.286 140 121.47c2.516-3.093 6.073-5.042 9.96-3.33"
      stroke="#000"
      strokeWidth={1.031}
      strokeMiterlimit={10}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M104.35 129.388c-.928.618-1.845 1.258-2.773 1.907a2.28 2.28 0 0 0-.815 1.942 2.276 2.276 0 0 0 1.124 1.78c1.567 1.031 3.268 2.464 4.897 3.444a8.331 8.331 0 0 0 1.207-3.64c.587-.866 1.144-1.763 1.732-2.629l-5.372-2.804Z"
      fill="#000"
      stroke="#fff"
      strokeWidth={1.031}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m130.635 120.933 4.763-5.454-14.084-12.238-4.732 5.093 14.053 12.599Z"
      fill="#fff"
    />
    <path
      d="m141.703 124.996 25.641 24.074"
      stroke="#fff"
      strokeWidth={1.031}
      strokeMiterlimit={10}
    />
    <path
      d="m113.062 114.19 1.207 1.31"
      stroke="#000"
      strokeWidth={1.031}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M112.949 50.587c-1.567 2.382-3.165 4.732-4.732 7.114.144 2.32.278 4.67.392 7.021 11.98 1.516 24.744 1.351 28.383.506v-7.506c-6.516.227-13.011.618-19.847-.165 1.681-2.35 3.815-5.238 5.496-7.589-2.186-2.711-4.289-5.155-6.475-7.866a152.435 152.435 0 0 1 21.28-1.114l.33-7.361c-9.568.051-20.064.474-29.755 2.68l-.619 7.558c1.939 2.217 3.619 4.454 5.547 6.722Z"
      fill="#fff"
      stroke="#FF5E18"
      strokeWidth={1.031}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M119.981 84.435v-4.619c-8.145-.505-11.702 2.598-14.61 7.836l6.495 5.093c6.259-2.124 7.63-5.485 8.115-8.31Z"
      fill="#FF5E18"
      stroke="#000"
      strokeWidth={1.031}
      strokeMiterlimit={10}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M125.271 79.9a6.754 6.754 0 0 0-5.042-.372c-.979 1.093-1.093 3.093-.423 4.908 1.176 1.227 4.423.783 5.382.051a10.463 10.463 0 0 1 .083-4.588Z"
      fill="#FF5E18"
      stroke="#000"
      strokeWidth={1.031}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M125.179 84.487a7.505 7.505 0 0 1 .083-4.588c4.052 2.351 5.846 3.887 4.866 10.135-1.845 11.702-20.465 8.671-4.949-5.547Z"
      fill="#FF5E18"
      stroke="#000"
      strokeWidth={1.031}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M124.97 82.189c2.32 3.7 1.258 7.278-.587 9.939M119.416 82.755a13.55 13.55 0 0 0-7.217 3.66"
      stroke="#000"
      strokeWidth={1.031}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M134.084 182.496a10.218 10.218 0 0 0-4.928-4.309"
      stroke="#fff"
      strokeWidth={1.031}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M92.879 170.876c6.444.701 9.279.454 8.124 6.97-.288 1.567-1.66 7.67-2.546 11.619m-.732 3.093a9.392 9.392 0 0 1-.67 1.763c-1.29 2.186-3.64 1.031-6.578.835"
      stroke="#000"
      strokeWidth={1.031}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M99.399 171.968a21.84 21.84 0 0 1 5.155 3.412 3.181 3.181 0 0 1 .68 2.836 141.148 141.148 0 0 1-3.093 14.918c-.783 2.712-2.413 3.331-4.897 2.908l-3.248-.412"
      stroke="#000"
      strokeWidth={1.031}
      strokeMiterlimit={10}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M103.625 183.052c9.681 2.753 17.805 5.041 26.084 9.351l-2.371 4.815a182.908 182.908 0 0 0-24.858-8.475c-2.526-.681-.794-6.248 1.145-5.691Z"
      fill="#fff"
      stroke="#000"
      strokeWidth={1.031}
      strokeMiterlimit={10}
    />
    <path
      d="M87.14 180.144c.392.866.753 1.732 1.114 2.577 1.031 2.464.474 2.124 3.093 2.382 2.619.257 2.062.165 3.97-1.825 1.907-1.99 3.814-3.949 5.711-5.908"
      stroke="#25211A"
      strokeWidth={1.031}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M85.598 225.859a7.21 7.21 0 0 0 2.969 1.485c2.63.67 4.31.299 5.794-1.155 3.475-3.381 3.867-11.341 3.021-15.362-.36-1.68-1.175-2.526-3.578-3.392a11.354 11.354 0 0 0-3.98-.752"
      stroke="#000"
      strokeWidth={1.031}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M170.475 228.861c-.783-1.938-1.598-3.835-2.412-5.743-1.959-4.65-2.712-6.773 2.217-9.743 3.093-1.845 7.392-2.938 9.825-1.227 1.928 1.341 4.227 9.743 4.897 12.177.784 2.66.506 4.536-3.639 6.547-.815.391-1.619.783-2.464 1.175-3.918 1.907-6.774.67-8.424-3.186Z"
      fill="#807e7e"
      stroke="#000"
      strokeWidth={1.031}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M57.95 275.946c2.628 3.093 7.278 3.526 11.897 3.299 5.825-.309 8.96-1.123 12.372-2.629 7.145-3.216 9.527-4.175 14.115-4.928 4.753-.814 8.145-.753 11.836-2.711M72.688 266.173c2.33.113 4.732 1.237 7.278 3.33M83.36 254.305c1.092-.309 3.608.31 5.154 1.372"
      stroke="#fff"
      strokeWidth={1.031}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M109.812 246.325c-10.382.639-12.516 14.641-18.93 26.683M85.07 232.603c5.403 2.134 16.012 3.144 25.92 1.68M166.773 239.634c3.279 3.165 25.281-2.825 25.776-9.352M173.809 268.245c4.732 2.186 6.021 5.712 7.897 10.052.804 1.898 1.681 3.805 2.598 5.537 3.33 6.248 5.856 8.042 13.403 7.619 5.156-.278 10.806-2.062 12.259-5.856.835-2.155.639-4.866.423-8.083"
      stroke="#fff"
      strokeWidth={1.031}
      strokeMiterlimit={10}
    />
    <path
      d="M181.671 282.915a13.028 13.028 0 0 0-2.062-4.176M208.637 273.421c-4.619-4.124-13.104-3.269-20.496 1.123M170.789 249.036c6.3 3.784 7.217 17.167 9.094 25.229M132.239 150.699c-.814-.814-.928-2.381.33-3.897l10.527-12.764M139.125 149.627l9.011-10.496M143.859 153.936l9.011-10.321M149.031 157.968l8.455-9.651M153.602 193.836l13.496 1.145 12.846-7.867"
      stroke="#fff"
      strokeWidth={1.031}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M208.241 183.64c1.993 0 3.609-1.528 3.609-3.413 0-1.885-1.616-3.413-3.609-3.413-1.993 0-3.608 1.528-3.608 3.413 0 1.885 1.615 3.413 3.608 3.413Z"
      fill="#FF5E18"
      stroke="#FF5E18"
      strokeWidth={1.031}
      strokeMiterlimit={10}
    />
    <path
      d="M164.798 235.139c-12.156 2.216-23.549 1.99-23.404-15.465 0-5.888-.846-11.991-5.856-12.826-3.269-.557-5.991.752-8.424 2.691-6.248 4.897-8.145 7.887-12.259 7.021"
      stroke="#807e7e"
      strokeWidth={1.031}
      strokeMiterlimit={10}
    />
    <path
      d="M54.324 205.063c9.547-8.825 14.672-14.001 21.476-22.373"
      stroke="#807e7e"
      strokeWidth={1.031}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M109.812 75.951a97.351 97.351 0 0 0 27.766 2.01"
      stroke="#000"
      strokeWidth={1.031}
      strokeMiterlimit={10}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m141.782 35.688-8.145.227.392-4.258h7.949l-.196 4.031ZM130.478 63.66c-5.533.25-11.075.174-16.599-.226.103 1.237.247 2.433.361 3.67 5.455.615 10.949.812 16.434.588-.082-1.35-.144-2.67-.196-4.032Z"
      fill="#25211A"
    />
    <path
      d="M101.638 93.723 81.399 78.155a1.3 1.3 0 1 1 1.485-2.124l32.085 24.384M89.93 93.19l-8.599-6.63a1.29 1.29 0 1 1 1.485-2.061l28.312 21.506m-9.97-4.185-8.063-6.186 8.063 6.186ZM86.554 99.004l-5.805-4.486a1.286 1.286 0 0 1-.479-1.91 1.286 1.286 0 0 1 1.498-.454c.175.066.335.169.466.303l25.208 19.042m-6.98-1.763-10.722-8.248 10.722 8.248Z"
      stroke="#fff"
      strokeWidth={1.031}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m168.633 148.286-9.403 5.763 7.248 7.651 9.548-6.052-7.393-7.362ZM186.992 142.265l-7.804-.444 7.495 7.083 7.65.671-7.341-7.31ZM145.418 184.227l.031-4.557 7.836 8.227.309 5.939-8.176-9.609Z"
      fill="#000"
      stroke="#fff"
      strokeWidth={1.031}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="m96.426 113.128 4.763 2.907" stroke="#fff" strokeWidth={1.031} strokeMiterlimit={10} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M114.797 51.898c-4.065.259-8.142.259-12.207 0 .062.896.113 1.762.196 2.66 4.02.372 8.061.458 12.094.257-.021-.959-.052-1.938-.083-2.917ZM115.388 37.091l-5.021.505.227-6.413 4.897-.474-.103 6.382ZM135.741 53.608h-5.011l.165-2.887 4.898-.134-.052 3.02Z"
      fill="#fff"
    />
    <path
      d="m187.613 87.704-1.938.103c-3.021.196-1.093 3.279 1.031 3.165h1.031c1.546-.082 3.474 2.908 1.433 3.217l-2.691.423"
      stroke="#FF5E18"
      strokeWidth={2.062}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M149.784 87.375h-1.505c-1.712 0-1.908 2.206-.258 2.206h.34c1.794 0 1.815 2.609-.392 2.526h-1.453M94.554 173.517l-1.814-.145a1.327 1.327 0 0 0-1.084.209 1.316 1.316 0 0 0-.174 1.997 1.32 1.32 0 0 0 1.031.392h.392c2.124.165 2.206 3.279-.423 2.97l-1.732-.165"
      stroke="#FF5E18"
      strokeWidth={1.547}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M110.709 147.73c-4.65-.454-9.279-1.031-14.434-1.743-1.423.784-2.206 8.434-.114 8.991a203.52 203.52 0 0 0 12.465 1.649c3.021.31 6.011.567 9.042.732 4.784.31 9.568.444 14.496.506h2.063a6.794 6.794 0 0 1-1.207-3.547 15.625 15.625 0 0 1 0-2.753l-.866-.887-1.742-1.742a290.83 290.83 0 0 1-19.703-1.206Z"
      fill="#807e7e"
    />
    <path
      d="m157.827 190.362-.784-8.423 12.259-16.713 18.506-11.506 8.506.721"
      stroke="#25211A"
      strokeWidth={1.031}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m167.096 194.981-13.496-1.144-.67-12.713 13.547-19.424 20.208-12.795 14.166 1.258v13.805l-10.238 15.115-10.671 8.032-12.846 7.866Z"
      fill="url(#sigmanauts_svg__j)"
      stroke="#000"
      strokeWidth={1.031}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M162.663 190.197c-1.392-.062-2.763-.113-4.124-.196-.279-2.804-.526-5.598-.805-8.423l12.29-16.692L188.5 153.38c2.856.258 5.681.505 8.506.732v8.093c-.557.918-1.145 1.846-1.712 2.763-5.516 8.908-1.227 16.806 4.568 8.548 2.855-4.032 6.918-2.062 7.279 1.031-4.898-1.031-5.372 3.474-9.403 9.279-5.073 7.217-15.569 4.309-25.281 1.433-2.062.721-2.33 1.814-2.062 5.011-1.371.164-4.309-.732-4.784-2.3l-2.948 2.227Z"
      fill="url(#sigmanauts_svg__k)"
      stroke="#FF5E18"
      strokeWidth={1.031}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M93.352 78.497c11.145 8.197 14.929 11.929 22.733 17.775"
      stroke="#fff"
      strokeWidth={1.031}
      strokeLinejoin="round"
    />
    <path
      d="M101.051 146.636c7.083.897 13.578 1.536 20.496 1.928"
      stroke="#000"
      strokeWidth={1.031}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M101.195 116.035c5.928.65 9.351.784 13.795 2.062 3.474.918 4.815 1.567 5.856 2.681a38.383 38.383 0 0 1 3.557 5.351c1.196 2.773-.588 5.093-2.774 3.722a38.026 38.026 0 0 1-2.938-2.516 3.704 3.704 0 0 1-2.83 4.54 3.705 3.705 0 0 1-1.964-.117c.588 3.464-3.887 5.928-6.186 2.825a9.284 9.284 0 0 0-3.732-2.887 36.805 36.805 0 0 1-6.186-2.01c-2.846-3.124-2.114-11.434 3.402-13.651Z"
      fill="#fff"
      stroke="#000"
      strokeWidth={1.031}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M113.897 131.719a13.661 13.661 0 0 0-2.124-2.918M118.692 127.295a9.686 9.686 0 0 0-1.68-2.526"
      stroke="#000"
      strokeWidth={1.031}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M137.472 159.319c-2.97.113-4.124-2.413-4.403-4.98-.165-1.516.062-4.794.959-6.083 1.65-2.372 5.372-.588 5.258 3.309 2.609-2.062 5.403 2.124 4.98 5.568 1.877-3.165 5.743-.114 5.32 4.124-.216 2.01-1.454 4.052.114 5.877l-1.031 1.701c-1.599.062-4.537.113-5.516-4.227-3.001.587-5.351-2.578-5.681-5.289Z"
      fill="#fff"
      stroke="#000"
      strokeWidth={1.031}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M139.291 151.564c-1.536 1.506-1.814 5.094-1.814 7.754"
      stroke="#000"
      strokeWidth={1.031}
      strokeMiterlimit={10}
    />
    <path
      d="M144.272 157.133a11.57 11.57 0 0 0-1.113 7.423"
      stroke="#000"
      strokeWidth={1.031}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m145.504 173.206 6.805-9.465 7.165 8.001-6.547 9.382-7.423-7.918Z"
      fill="#000"
      stroke="#fff"
      strokeWidth={1.031}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M193.378 199.435c13.073-8.764 13.774 15.28-1.825 27.745 25.229-18.476 35.693-44.571 34.611-73.13a119.974 119.974 0 0 0-3.341-23.487m-13.238-30.147c-8.506-13.609-19.878-25.053-34.601-31.24"
      stroke="#fff"
      strokeWidth={1.031}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M101.886 64.248a31.389 31.389 0 0 1-3.382-14.166c0-18.084 15.465-32.724 34.632-32.724a36.007 36.007 0 0 1 16.826 4.124"
      stroke="#807e7e"
      strokeWidth={1.031}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M173.136 175.442c1.993 0 3.608-1.528 3.608-3.413 0-1.885-1.615-3.413-3.608-3.413s-3.609 1.528-3.609 3.413c0 1.885 1.616 3.413 3.609 3.413ZM182.911 181.484c.786 0 1.423-.6 1.423-1.34 0-.74-.637-1.34-1.423-1.34s-1.423.6-1.423 1.34c0 .74.637 1.34 1.423 1.34ZM178.434 193.692c2.921 0 5.289-2.258 5.289-5.042s-2.368-5.042-5.289-5.042-5.289 2.258-5.289 5.042 2.368 5.042 5.289 5.042Z"
      fill="#FF5E18"
      stroke="#FF5E18"
      strokeWidth={1.031}
      strokeMiterlimit={10}
    />
    <path
      d="M159.676 131.296a30.222 30.222 0 0 1 8-11.475 30.264 30.264 0 0 1 16.301.196"
      stroke="#fff"
      strokeWidth={1.031}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M211.041.583a24.96 24.96 0 0 1 29.734 18.981 24.978 24.978 0 0 1-19.012 29.766 24.962 24.962 0 0 1-26.385-37.817A24.925 24.925 0 0 1 211.041.582Z"
      fill="url(#sigmanauts_svg__l)"
    />
    <path d="M199.33 33.07a4.702 4.702 0 1 0 0-9.402 4.702 4.702 0 0 0 0 9.403Z" fill="#141414" />
    <path
      d="M238.847 7.161c1.67 2.495-7.475 11.599-20.445 20.3-12.97 8.703-24.827 14.023-26.476 11.229"
      stroke="#585858"
      strokeWidth={1.031}
      strokeMiterlimit={10}
    />
    <path
      d="M199.135 116.263c.392 7.897.278 8.485-3.217 15.671"
      stroke="#fff"
      strokeWidth={1.031}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="sigmanauts_svg__a"
        x1={136.063}
        y1={301.571}
        x2={221.637}
        y2={234.04}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF5E18" />
        <stop offset={1} stopColor="#141414" />
      </linearGradient>
      <linearGradient
        id="sigmanauts_svg__b"
        x1={18.303}
        y1={46.3}
        x2={22.652}
        y2={175.274}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF5E18" />
        <stop offset={1} stopColor="#141414" />
      </linearGradient>
      <linearGradient
        id="sigmanauts_svg__c"
        x1={87.09}
        y1={241.773}
        x2={237.617}
        y2={76.295}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF5E18" />
        <stop offset={1} stopColor="#141414" />
      </linearGradient>
      <linearGradient
        id="sigmanauts_svg__d"
        x1={63.027}
        y1={113.22}
        x2={45.593}
        y2={109.925}
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset={1} stopColor="#EDDCB9" />
      </linearGradient>
      <linearGradient
        id="sigmanauts_svg__e"
        x1={175.239}
        y1={277.343}
        x2={210.293}
        y2={274.765}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF5E18" />
        <stop offset={1} stopColor="#141414" />
      </linearGradient>
      <linearGradient
        id="sigmanauts_svg__f"
        x1={73.687}
        y1={276.312}
        x2={107.195}
        y2={242.288}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF5E18" />
        <stop offset={1} stopColor="#141414" />
      </linearGradient>
      <linearGradient
        id="sigmanauts_svg__g"
        x1={-767622}
        y1={-572554}
        x2={-723842}
        y2={-554047}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D97316" />
        <stop offset={1} stopColor="#25211A" />
      </linearGradient>
      <linearGradient
        id="sigmanauts_svg__h"
        x1={162.87}
        y1={26.291}
        x2={101.524}
        y2={61.861}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF5E18" />
        <stop offset={1} stopColor="#141414" />
      </linearGradient>
      <linearGradient
        id="sigmanauts_svg__i"
        x1={160.623}
        y1={65.65}
        x2={160.623}
        y2={227.179}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF5E18" />
        <stop offset={1} stopColor="#141414" />
      </linearGradient>
      <linearGradient
        id="sigmanauts_svg__j"
        x1={135.38}
        y1={206.431}
        x2={159.197}
        y2={199.085}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} />
      </linearGradient>
      <linearGradient
        id="sigmanauts_svg__k"
        x1={166.478}
        y1={163.932}
        x2={191.222}
        y2={187.645}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF5E18" />
        <stop offset={1} stopColor="#141414" />
      </linearGradient>
      <radialGradient
        id="sigmanauts_svg__l"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(148.173 103.168 42.792) scale(17.5953)"
      >
        <stop stopColor="#FF5E18" />
        <stop offset={0.66} stopColor="#FF7C44" />
        <stop offset={1} stopColor="#D97316" stopOpacity={0} />
      </radialGradient>
    </defs>
  </svg>
);

export default SvgSigmanauts;
